import React from 'react';
import PropTypes from 'prop-types';

function SelectInput({
  children, value, onChange, label, id,
}) {
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <select
        className="form-control btn-square digits"
        id={id}
        value={value}
        onChange={onChange}
      >
        {children}
      </select>
    </div>
  );
}

SelectInput.propTypes = {
  children: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectInput;
